(function () {
  'use strict';

  if (window.FellinoraCommunityBenefitsSingleImageLoaded) {
    return;
  }

  window.FellinoraCommunityBenefitsSingleImageLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (!section || section.dataset.fcbInitialized === 'true') {
      return;
    }

    section.dataset.fcbInitialized = 'true';
    section.classList.add('fcb-js');

    var staggerItems = section.querySelectorAll('[data-fcb-stagger]');

    staggerItems.forEach(function (item, index) {
      var explicitDelay = Number(item.getAttribute('data-fcb-delay')) || 0;
      var delay = explicitDelay || Math.min(index * 120, 480);
      item.style.setProperty('--fcb-delay', delay + 'ms');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      section.classList.add('fcb-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        section.classList.add('fcb-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    });

    observer.observe(section);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fcb-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
